
export const BOOKING_STATUS_CONFIG: Record<string, { label: string; color: string; solid?: boolean }> = {
  BOOKED: { label: 'Booked', color: '#1B5E20', solid: true },
  CHECKED_IN: { label: 'Checked In', color: '#2E7D32' },
  CANCELLED: { label: 'Cancelled', color: '#C62828' },
  NO_SHOW: { label: 'No Show', color: '#E65100' },
  IN_PROGRESS: { label: 'In Progress', color: '#6A1B9A' },
};

export const bookingStatusConfig = (status: string): { label: string; color: string; solid?: boolean } =>
  BOOKING_STATUS_CONFIG[status] || { label: status, color: '#78909C' };
